"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTree = getTree;

var _lodash = _interopRequireDefault(require("lodash.clonedeep"));

var _lodash2 = _interopRequireDefault(require("lodash.get"));

var _lodash3 = _interopRequireDefault(require("lodash.isnil"));

var _treeDeepLevel = require("./constants/treeDeepLevel");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getFieldValue(flatNode, fieldPath) {
  return (0, _lodash2["default"])(flatNode, fieldPath);
}

function getRootFlatNodes(allFlatNodes, options) {
  return allFlatNodes.filter(function (flatNode) {
    return (0, _lodash3["default"])(getFieldValue(flatNode, options.parentIdFieldPath));
  });
}

function getChildren(parentFlatNode, allFlatNodes, options) {
  var parentId = getFieldValue(parentFlatNode, options.idFieldPath);
  return allFlatNodes.filter(function (flatNode) {
    return parentId === getFieldValue(flatNode, options.parentIdFieldPath);
  });
}

function mapToTree(rootFlatNodes, allFlatNodes, options) {
  var deepLevel = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _treeDeepLevel.TREE_DEEP_LEVEL.INITIAL;
  var currentDeepLevel = deepLevel + 1;
  return rootFlatNodes.map(function (flatNode) {
    var flatChildren = getChildren(flatNode, allFlatNodes, options);
    var treeChildren = null;

    if (flatChildren.length > 0) {
      treeChildren = mapToTree(flatChildren, allFlatNodes, options, currentDeepLevel);
    }

    return _objectSpread(_objectSpread({}, flatNode), {}, {
      children: treeChildren,
      deepLevel: currentDeepLevel
    });
  });
}

function getTree(allFlatNodes, options) {
  var rootFlatNodes = getRootFlatNodes((0, _lodash["default"])(allFlatNodes), options);
  return mapToTree(rootFlatNodes, allFlatNodes, options);
}